/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_profile_tooltip_combined_pos_gained = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Both drivers combined positions gained vs qualifying grid per race`)
};

const es_f1_profile_tooltip_combined_pos_gained = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posiciones ganadas combinadas de ambos pilotos vs parrilla de clasificación por carrera`)
};

const de_f1_profile_tooltip_combined_pos_gained = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kombinierte gewonnene Positionen beider Fahrer vs. Qualifying-Startplatz pro Rennen`)
};

const nl_f1_profile_tooltip_combined_pos_gained = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gecombineerde gewonnen posities van beide coureurs t.o.v. kwalificatiegrid per race`)
};

const fr_f1_profile_tooltip_combined_pos_gained = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Positions gagnées vs grille de qualification par les deux pilotes combinés par course`)
};

const it_f1_profile_tooltip_combined_pos_gained = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posizioni guadagnate combinate di entrambi i piloti rispetto alla griglia di qualifica per gara`)
};

const pt_br2_f1_profile_tooltip_combined_pos_gained = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posições ganhas combinadas de ambos os pilotos vs grid de classificação por corrida`)
};

const pt_f1_profile_tooltip_combined_pos_gained = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posições ganhas combinadas de ambos os pilotos vs grelha de qualificação por corrida`)
};

const ja_f1_profile_tooltip_combined_pos_gained = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レースごとの両ドライバー合算の予選グリッドからの獲得ポジション`)
};

const zh_f1_profile_tooltip_combined_pos_gained = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`两位车手相比排位赛每场合计获得的名次`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_profile_tooltip_combined_pos_gained = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_profile_tooltip_combined_pos_gained(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_profile_tooltip_combined_pos_gained", locale)
	if (locale === "en") return en_f1_profile_tooltip_combined_pos_gained(inputs)
	if (locale === "es") return es_f1_profile_tooltip_combined_pos_gained(inputs)
	if (locale === "de") return de_f1_profile_tooltip_combined_pos_gained(inputs)
	if (locale === "nl") return nl_f1_profile_tooltip_combined_pos_gained(inputs)
	if (locale === "fr") return fr_f1_profile_tooltip_combined_pos_gained(inputs)
	if (locale === "it") return it_f1_profile_tooltip_combined_pos_gained(inputs)
	if (locale === "pt-BR") return pt_br2_f1_profile_tooltip_combined_pos_gained(inputs)
	if (locale === "pt") return pt_f1_profile_tooltip_combined_pos_gained(inputs)
	if (locale === "ja") return ja_f1_profile_tooltip_combined_pos_gained(inputs)
	return zh_f1_profile_tooltip_combined_pos_gained(inputs)
};